/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';

// *************************************************************************************
// 
// FileAccessDto
// 
// *************************************************************************************
export interface FileAccessDto {
    fileAccess: number;
    docType: number;
    localPath: string;
    nameEN: string;
    nameDE: string;
}

export function FileAccessDtoFromJSON(json: any): FileAccessDto {
    return FileAccessDtoFromJSONTyped(json, false);
}

export function FileAccessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileAccessDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        fileAccess: json['fileAccess'],
        docType: json['docType'],
        localPath: json['localPath'],
        nameEN: json['nameEN'],
        nameDE: json['nameDE'],
    };
}

export function FileAccessDtoToJSON(value?: FileAccessDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        fileAccess: value.fileAccess,
        docType: value.docType,
        localPath: value.localPath,
        nameEN: value.nameEN,
        nameDE: value.nameDE,
    };
}

// *************************************************************************************
// 
// ServiceInterval
// 
// *************************************************************************************
export interface ServiceInterval {
    workingHours: number;
    serviceName: string;
    machineTypeId: number;
    engineTypeId: number;
    refServiceId?: number;
    documentAccess?: string;
    fileAccess?:FileAccessDto;
    // optional. Für zukünftige Erweiterung. Aktuell 1 Eintrag!
    // fileAccessList?: Array<FileAccessDto>;
}

export function ServiceIntervalFromJSON(json: any): ServiceInterval {
    return ServiceIntervalFromJSONTyped(json, false);
}
 
export function ServiceIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceInterval {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        workingHours: json['workingHours'],
        serviceName: json['serviceName'],
        machineTypeId: json['machineTypeId'],
        engineTypeId: json['engineTypeId'],
        refServiceId: !exists(json, 'refServiceId') ? undefined : json['refServiceId'],
        documentAccess: !exists(json, 'documentAccess') ? undefined : json['documentAccess'],
        fileAccess: !exists(json, 'fileAccess') ? undefined : FileAccessDtoFromJSON(json['fileAccess']),
    };
}
 
export function ServiceIntervalToJSON(value?: ServiceInterval | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        workingHours: value.workingHours,
        serviceName: value.serviceName,
        machineTypeId: value.machineTypeId,
        engineTypeId: value.engineTypeId,
        refServiceId: value.refServiceId,
        documentAccess: value.documentAccess,
        fileAccess: FileAccessDtoToJSON(value.fileAccess),
    };
}

// *************************************************************************************
// 
// MachineService
// 
// *************************************************************************************
export interface MachineService {
    id: number;
    machineId: number;
    serialNumber: string;
    serviceName?: string | null;
    serviceHours?: number | null;
    serviceDate?: Date | null;
    workingHours?: number | null;
    entryDate: Date;
    technicianName?: string | null;
    technicianEmail?: string | null;
    machineTypeId?: number | null;
    engineTypeId?: number | null;
}

export function MachineServiceFromJSON(json: any): MachineService {
    return MachineServiceFromJSONTyped(json, false);
}

export function MachineServiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineService {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        machineId: json['machineId'],
        serialNumber: json['serialNumber'],
        serviceName: !exists(json, 'serviceName') ? undefined : json['serviceName'],
        serviceHours: !exists(json, 'serviceHours') ? undefined : json['serviceHours'],
        serviceDate: !exists(json, 'serviceDate') || json['serviceDate'] === null
            ? undefined
            : new Date(json['serviceDate']),
        workingHours: !exists(json, 'workingHours') ? undefined : json['workingHours'],
        entryDate: new Date(json['entryDate']),
        technicianName: !exists(json, 'technicianName') ? undefined : json['technicianName'],
        technicianEmail: !exists(json, 'technicianEmail') ? undefined : json['technicianEmail'],
        machineTypeId: !exists(json, 'machineTypeId') ? undefined : json['machineTypeId'],
        engineTypeId: !exists(json, 'engineTypeId') ? undefined : json['engineTypeId'],
    };
}

export function MachineServiceToJSON(value?: MachineService | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        machineId: value.machineId,
        serialNumber: value.serialNumber,
        serviceName: value.serviceName,
        serviceHours: value.serviceHours,
        serviceDate: value.serviceDate === undefined || value.serviceDate === null
            ? undefined
            : value.serviceDate.toISOString(),
        workingHours: value.workingHours,
        entryDate: value.entryDate.toISOString().substring(0, 10),
        technicianName: value.technicianName,
        technicianEmail: value.technicianEmail,
        machineTypeId: value.machineTypeId,
        engineTypeId: value.engineTypeId,
    };
}

// *************************************************************************************
// 
// MachineServiceInfo
// 
// *************************************************************************************
/**
 * 
 * @export
 * @interface MachineServiceInfo
 */
export interface MachineServiceInfo {
    machineTypeId: number;
    engineTypeId?: number | null;
    isValid: boolean;
}

export function MachineServiceInfoFromJSON(json: any): MachineServiceInfo {
    return MachineServiceInfoFromJSONTyped(json, false);
}
 
export function MachineServiceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineServiceInfo {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        machineTypeId: json['machineTypeId'],
        engineTypeId: !exists(json, 'engineTypeId') ? undefined : json['engineTypeId'],
        isValid: json['isValid'],
    };
}
 
export function MachineServiceInfoToJSON(value?: MachineServiceInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        machineTypeId: value.machineTypeId,
        engineTypeId: value.engineTypeId,
        isValid: value.isValid,
    };
}

/**
 * 
 * @export
 * @interface MaintenanceInfoDto
 */
export interface MaintenanceInfoDto {
    /**
     * 
     * @type {number}
     * @memberof MaintenanceInfoDto
     */
    currentRuntimeHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceInfoDto
     */
    serviceRuntimeHour?: number | null;
    /**
     * 
     * @type {Array<MachineService>}
     * @memberof MaintenanceInfoDto
     */
    machineServices: Array<MachineService>;
    /**
     * 
     * @type {Array<ServiceInterval>}
     * @memberof MaintenanceInfoDto
     */
    serviceIntervals: Array<ServiceInterval>;
    /**
     * 
     * @type {ServiceInterval}
     * @memberof MaintenanceInfoDto
     */
    readonly nextService?: ServiceInterval | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceInfoDto
     */
    readonly nextServiceHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceInfoDto
     */
    machineServiceInfo?: MachineServiceInfo | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceInfoDto
     */
    readonly isValid: boolean;
}

export function MaintenanceInfoDtoFromJSON(json: any): MaintenanceInfoDto {
    return MaintenanceInfoDtoFromJSONTyped(json, false);
}

export function MaintenanceInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaintenanceInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        currentRuntimeHour: !exists(json, 'currentRuntimeHour') ? undefined : json['currentRuntimeHour'],
        serviceRuntimeHour: !exists(json, 'serviceRuntimeHour') ? undefined : json['serviceRuntimeHour'],
        machineServices: !exists(json, 'machineServices')
            ? []
            : (json['machineServices'] as Array<any>).map(MachineServiceFromJSON),
        serviceIntervals: (json['serviceIntervals'] as Array<any>).map(ServiceIntervalFromJSON),
        nextService: !exists(json, 'nextService') ? undefined : ServiceIntervalFromJSON(json['nextService']),
        nextServiceHour: !exists(json, 'nextServiceHour') ? undefined : json['nextServiceHour'],
        machineServiceInfo: !exists(json, 'machineServiceInfo') ? undefined : MachineServiceInfoFromJSON(json['machineServiceInfo']),
        isValid: !exists(json, 'isValid') ? undefined : json['isValid'],
    };
}

export function MaintenanceInfoDtoToJSON(value?: MaintenanceInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        currentRuntimeHour: value.currentRuntimeHour,
        serviceRuntimeHour: value.serviceRuntimeHour,
        machineServices: (value.machineServices as Array<any>).map(MachineServiceToJSON),
        serviceIntervals: (value.serviceIntervals as Array<any>).map(ServiceIntervalToJSON),
        // 'nextService', 'nextServiceHour', 'isValid' sind read-only (computed) -> nicht zurückschreiben
        machineServiceInfo: MachineServiceInfoToJSON(value.machineServiceInfo),
    };
}

